export function getBackendUrl(): string {
  const url = import.meta.env.VITE_BACKEND_URL;
  if (!url) {
    throw new Error('VITE_BACKEND_URL is not configured');
  }
  return url.replace(/\/$/, '');
}
